const ProductType = {
  SET_ADD_PRODUCT: "SET_ADD_PRODUCT",
  SET_PRODUCT_LIST: "SET_PRODUCT_LIST",
  SET_ADD_VARIANT: "SET_ADD_VARIANT",
  SET_VARIANT_PRODUCT_LIST: "SET_VARIANT_PRODUCT_LIST",
  CHANGE_PRODUCT_STATUS: "CHANGE_PRODUCT_STATUS",
  SET_ACTIVATE_ECOM_PRODUCT: "SET_ACTIVATE_ECOM_PRODUCT",
  SET_COLORS: "SET_COLORS",
  DELETE_VARIANT: "DELETE_VARIANT",
  UPDATE_VARIANT: "UPDATE_VARIANT",
  SET_PRODUCT_DETAILS: "SET_PRODUCT_DETAILS",
  UPDATE_PRODUCT: "UPDATE_PRODUCT",
  GET_PO_PRODUCT_LIST: "GET_PO_PRODUCT_LIST",
  UPDATE_PRODUCT_IMAGE: "UPDATE_PRODUCT_IMAGE",
  CHANGE_PRODUCT_TYPE: "CHANGE_PRODUCT_TYPE",
  SET_BUYER_LIST: "SET_BUYER_LIST",
  MAP_PRODUCT: "MAP_PRODUCT",
  DOWNLOAD_PRODUCT_LIST: "DOWNLOAD_PRODUCT_LIST",
};

export interface AddProduct {
  product_name: string;
  barcode: string;
  selling_qty: number;
  description: string;
  ex_factory_price: any;
  tax: number;
  vendor_id: number;
  category_id: number;
  sub_category_id: number;
  child_category_id: number;
  is_variant: any;
  product_specification: string;
  product_image: any;
  product_code: string;
  gallery: any;
  min_sale_qty: number;
  mrp: number;
}

export interface GetProduct {
  limit: number;
  search: any;
  page: number;
}

export interface AddProductVariant {
  product_id: number;
  product_code: any;
  barcode: any;
  product_size: any;
  product_color: string;
  qty: any;
  mrp: any;
  landing_cost: any;
}

export interface GetVariantProduct {
  productId: number;
}

export interface ChangeProductStatus {
  id: any;
  status: string;
}

export interface ActivateEcomProduct {
  id: number;
  barcode: string;
  description: string;
  selling_price: any;
  tax: number;
  category_id: number;
  sub_category_id: number;
  child_category_id: number;
  is_variant: any;
  product_specification: string;
  product_image: any;
  status: number;
  gallery: any;
}

export interface DeleteVariant {
  id: number;
}

export interface UpdateProductVariant {
  id: number;
  product_id: number;
  product_code: any;
  barcode: any;
  product_size: any;
  product_color: string;
  qty: any;
  mrp: any;
  landing_cost: any;
}

export interface GetProductDetails {
  id: number;
}

export interface UpdateProduct {
  id: number;
  product_name: string;
  barcode: string;
  selling_qty: number;
  description: string;
  ex_factory_price: any;
  tax: number;
  vendor_id: number;
  category_id: number;
  sub_category_id: number;
  is_variant: any;
  product_specification: string;
  product_image: any;
  product_code: string;
  min_sale_qty: number;
  mrp: number;
}

export interface GetPoProductList {
  categoryId: any;
  subCategoryId: any;
  childCategoryId: any;
  vendorId: any;
  sellerUniqueId: any;
  city: string;
}

export interface UpdateProductImage {
  id: number;
  product_image: string;
}

export interface ChangeProductEcomStatus {
  id: number;
  product_ecom_status: string;
}

export interface GetBuyerList {
  productId: number;
}

export interface MapProduct {
  product_id: number;
  user_id: number;
}

export default ProductType;
